// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import 'flex.box/src/flexbox.css'

import customers from './customers.vue'

import router from './router'
import store from './store/store'

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { locale })

import VueMdijs from 'vue-mdijs'
import {
  mdiTrashCanOutline,
  mdiRestore,
  mdiPlus,
  mdiClose,
  mdiCreditCardOutline,
  mdiCreditCardCheckOutline,
  mdiDotsVertical
} from '@mdi/js';
//
VueMdijs.add({
  mdiTrashCanOutline,
  mdiRestore,
  mdiPlus,
  mdiClose,
  mdiCreditCardOutline,
  mdiCreditCardCheckOutline,
  mdiDotsVertical
})
Vue.use(VueMdijs)

import icon from '@components/c-icon/index.vue'
Vue.component('c-icon', icon)

import Vuex from 'vuex'
Vue.use(Vuex)

import fetch from './fetch.js'
Vue.use(fetch)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import messages from '../bookingForm/i8n/messages'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const i18n = new VueI18n({
    fallbackLocale: 'en',
    messages
})

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
    moment,
})

import GmapVue from 'gmap-vue'
Vue.use(GmapVue, {
  load: {
    // [REQUIRED] This is the unique required value by Google Maps API
    key: import.meta.env.VITE_GMAPS_KEY,
    // [OPTIONAL] This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    libraries: 'places,drawing',

    // This option was added on v3.0.0 but will be removed in the next major release.
    // If you already have an script tag that loads Google Maps API and you want to use it set you callback
    // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
    // to the `window` object, is the only requirement.
  //   customCallback: 'MyCustomCallback',
  },

  // [OPTIONAL] If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  autoBindAllEvents: false,

  // [OPTIONAL] If you want to manually install components, e.g.
  // import {GmapMarker} from 'gmap-vue/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,

  // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
  dynamicLoad: false,
})

Vue.config.productionTip = false
axios.defaults.baseURL = `/api`

Vue.prototype.$guardModel = "customer",


/* eslint-disable no-new */
new Vue({
  el: '#app',
    i18n,
  store,
  router,
  components: { customers }
})

